import React from 'react'
import { TabBar } from 'antd-mobile-v5'
import { useIntl } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'

import styles from './nav.module.css'

const NavIcon = ({ name, active }) => {
  return (
    <img src={require(`../../assets/images/nav_bar/${active ? name + '-active' : name}.png`)} className={styles.icon} />
  )
}

const NavTitle = ({ title, active }) => {
  return <div className={active ? styles['title-active'] : styles.title}>{title}</div>
}

export default function BottomNav({ isMainlandUser }) {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { pathname, search } = useLocation()

  if (pathname === '/members' || pathname === '/ecards' || ~search.indexOf('no_nav')) {
    return <div></div>
  }

  return (
    <TabBar
      className={styles['nav']}
      activeKey={pathname}
      onChange={(value) => {
        if (value === 'youzan') {
          window.location.href = 'https://shop18875151.youzan.com'
        } else {
          push(value)
        }
      }}
    >
      <TabBar.Item
        title={(active) => <NavTitle title={formatMessage({ id: 'home' })} active={active} />}
        key="/certs"
        icon={(active) => <NavIcon name={'certs'} active={active} />}
        onPress={() => push('/certs')}
      ></TabBar.Item>
      <TabBar.Item
        title={(active) => <NavTitle title={formatMessage({ id: 'navi-store' })} active={active} />}
        key="youzan"
        icon={(active) => <NavIcon name={'youzan'} active={active} />}
      ></TabBar.Item>
      <TabBar.Item
        title={(active) => <NavTitle title={formatMessage({ id: 'profile' })} active={active} />}
        key="/myProfile"
        icon={(active) => <NavIcon name={'mine'} active={active} />}
        onPress={() => push('/myProfile')}
      ></TabBar.Item>
    </TabBar>
  )
}
